import type { PersonById } from '../../../../services/personApi';
import { maskDocument } from '../../credit-analysis/utils/documentUtils';
import type { Party } from '../../../../types/LegalCase';

// Rótulo de uma parte do caso, em um lugar só: a lista de partes e o seletor de pagador do
// lançamento manual leem daqui. Desde a AF-3817 a parte guarda o nome no processo também com
// `personId` (adendo ao ADR 001); o nome resolvido do person só entra quando ele falta.
export const displayPartyName = (party: Party, resolved?: PersonById): string => {
    if (party.name) return party.name;
    if (resolved?.name) return resolved.name;
    if (party.personId) return 'Cadastrado em Pessoas';
    return '—';
};

// Documento exibido: local (contraparte externa) ou o resolvido do person, com máscara.
export const displayPartyDocument = (party: Party, resolved?: PersonById): string | null => {
    const doc = party.document || resolved?.document || null;
    return doc ? maskDocument(doc) : null;
};
